const treinoData = [
    {
        nome : 'Frequência',
        icon : 'mdi-heart',
        suffix : '%'
    },
    {
        nome : 'Potência',
        icon : 'mdi-engine',
        suffix : 'w'
    },
    {
        nome : 'Pace',
        icon : 'mdi-speedometer',
        suffix : 'min / km'
    },

]

export default {
    TREINODATA: treinoData,
}
